import React from "react";
import styled from "styled-components";

// #region SCOPED CSS
const StyledBICategoryCard = styled.div`
    &.category-card {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        border: 1px solid var(--backgrounds-and-lines-n-100, #3c485a);
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: stretch;
        justify-content: flex-start;
        flex: 1;
        min-width: 140px;
    }

    .category-header {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px;
        height: 77px;
        padding: 12px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .category-title {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        line-height: 18px;
        white-space: pre-line;
    }

    .category-body {
        padding: 2px 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
        justify-content: center;
    }

    .category-amount {
        color: var(--text-and-icons-green-500, #00bb00);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        text-align: center;
    }

    .category-percentage {
        color: var(--text-and-icons-green-500, #00bb00);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        text-align: center;
    }

    &.category-card--placeholder {
        .category-title,
        .category-amount,
        .category-percentage {
            color: var(--text-and-icons-gray-200, #7c868b);
        }
    }
`;
// #endregion

/**
 * BICategoryCard renders an individual category tile for the Recommended Category Allocation grid.
 *
 * @param {Object} props
 * @param {string} props.title - Category name (e.g., "SHORTS", "SWEATERS\nRUGBY\nSWEATS")
 * @param {string} props.amount - Formatted currency amount (e.g., "49.000 EUR")
 * @param {string} props.percentage - Formatted percentage (e.g., "7,2%")
 * @param {boolean} props.isPlaceholder - Whether this is a empty `-` placeholder card
 */
export default function BICategoryCard({ title = "-", amount = "-", percentage = "-", isPlaceholder = false }) {
    const cardClass = `category-card ${isPlaceholder ? "category-card--placeholder" : ""}`;

    return (
        <StyledBICategoryCard className={cardClass}>
            <div className="category-header">
                <div className="category-title">{title}</div>
            </div>
            <div className="category-body">
                <div className="category-amount">{amount}</div>
                <div className="category-percentage">{percentage}</div>
            </div>
        </StyledBICategoryCard>
    );
}
